import { useSelector } from "react-redux";
import twitterIcon from "../../../../icons/twitter.svg";
import { Field } from "redux-form";
import { validateLink } from "./ad_settings_validation";
import facebookIcon from "../../../../icons/facebook.svg";
import instagramIcon from "../../../../icons/instagram.svg";
import youtubeIcon from "../../../../icons/youtube.svg";
import React from "react";
import { formValueSelector } from "redux-form";
import { AD_SETTINGS_FORM_NAME } from "./constants";
const selector = formValueSelector(AD_SETTINGS_FORM_NAME);

export const SocialMediaLinksForm = props => {
  const linkSettings = [
    {
      imgAlt: "twitter",
      src: twitterIcon,
      name: "Twitter",
      inputName: "twitterLink",
      placeholder: "https://twitter.com/getredcircle",
      domain: "twitter.com",
    },
    {
      imgAlt: "facebook",
      src: facebookIcon,
      name: "Facebook",
      inputName: "facebookLink",
      placeholder: "https://www.facebook.com/GetRedCircle/",
      domain: "facebook.com",
    },
    {
      imgAlt: "instagram",
      src: instagramIcon,
      name: "Instagram",
      inputName: "instagramLink",
      placeholder: "https://www.instagram.com/getredcircle",
      domain: "instagram.com",
    },
    {
      imgAlt: "youtube",
      src: youtubeIcon,
      name: "YouTube",
      inputName: "youtubeLink",
      placeholder: "https://www.youtube.com/channel/URcFeijf20js",
      domain: "youtube.com",
    },
  ];

  const values = useSelector(state =>
    selector(state, ...linkSettings.map(({ inputName }) => inputName))
  );

  const links = ({ imgAlt, src, name, inputName, placeholder, domain }) => {
    return (
      <div className={"margin-bottom--large"}>
        <div className="flex-row-container">
          <img
            alt={imgAlt}
            src={src}
            className="margin-top--medium"
            style={{ alignSelf: "flex-start", width: 48 }}
          />
          <div className="margin-left--large width-100">
            <div className="redcircle-form-label">{name}</div>
            <Field
              component="input"
              name={inputName}
              type="text"
              className="form-control"
              placeholder={placeholder}
            />
            <div>
              <span className={"text-warning small"}>
                {validateLink(values[inputName], domain)[1]}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="margin-bottom--large">
        Share your social media accounts so advertisers can get to know your show and audience
        better.
      </div>
      {linkSettings.map(links)}
    </div>
  );
};
